// @unocss-include
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { withClassName } from '../../hooks.js';
export const ProgressRoot = withClassName(ProgressPrimitive.Root, 'layer-components:w-full layer-components:relative layer-components:overflow-hidden layer-components:border layer-components:border-default layer-components:rounded-lg');
export const ProgressIndicator = withClassName(ProgressPrimitive.Indicator, 'layer-components:bg-primary layer-components:w-full layer-components:h-6px layer-components:translate-x-[calc(-100%*(1-var(--value)))] layer-components:rounded-lg layer-components:transition-transform', 'layer-components:[&[data-state=complete]]:bg-accent', 'layer-variants:[&[data-color=accent]]:bg-accent');
const ProgressBase = function ProgressBase(_a) {
    var { ref, children, color, max = 100, value } = _a, props = __rest(_a, ["ref", "children", "color", "max", "value"]);
    return (_jsx(ProgressRoot, Object.assign({}, props, { value: value, max: max, ref: ref, children: _jsx(ProgressIndicator, { "data-color": color, 
            // @ts-ignore
            style: { '--value': (value || 0) / max } }) })));
};
export const Progress = Object.assign(ProgressBase, {
    Root: ProgressRoot,
    Indicator: ProgressIndicator,
});
//# sourceMappingURL=Progress.js.map